//  The purpose of this file is to add Google Analytics classes
//  to certain elements that are otherwise unreachable

const headerMenu = [...document.querySelectorAll('.header-menu')]

const brandMenu = document.querySelector('#menu-header-brands')
const brandLinks = [...brandMenu.querySelectorAll('.menu-link')]

const cart = document.querySelector('.menu-item.cart')
const cartLink = cart.querySelector('.menu-link')

headerMenu.forEach((menu) => {
  const menuLinks = [...menu.querySelectorAll('.menu-link')]

  menuLinks.forEach((link) => {
    link.classList.add('header_menu')
  })
})

brandLinks.forEach((link) => {
  link.classList.add('nav_click')
})

cartLink.classList.add('cart_icon')
